import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n';
import App from './App';
import { installStorageScoping } from './utils/storageScope';

installStorageScoping();

if (window.desktopAPI) {
  document.documentElement.classList.add('xph-desktop-app');
  document.body.classList.add('xph-desktop-app');
  window.desktopAPI.getMeta().then((meta) => {
    if (meta?.platform) {
      document.documentElement.setAttribute('data-desktop-platform', meta.platform);
      document.body.setAttribute('data-desktop-platform', meta.platform);
    }
    if (typeof meta?.isDarkMode === 'boolean') {
      document.documentElement.setAttribute('data-system-theme', meta.isDarkMode ? 'dark' : 'light');
    }
  }).catch(() => {
    // Non-blocking desktop metadata.
  });
  window.desktopAPI.onThemeUpdated((payload) => {
    if (typeof payload?.isDarkMode === 'boolean') {
      document.documentElement.setAttribute('data-system-theme', payload.isDarkMode ? 'dark' : 'light');
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);